<ng-template #templateEditAdd>
    <form [formGroup]="editForm" (ngSubmit)="onSubmit()" class="col-lg-12">
        <input type="hidden" [formGroup]="editForm" formControlName="id" />

        <div class="form-group">
            <h5><label for="codice" class="mandatory">Codice:</label></h5>
            <input [formGroup]="editForm" formControlName="codice" maxlength="255" type="text" class="form-control" placeholder="Inserisci il codice" [ngClass]="{
                    'form-control': true,
                    'is-invalid': submitted && f.codice.errors
                    }" />
            <div *ngIf="submitted && f.codice.errors" class="invalid-feedback" style="display: block;">
                <div *ngIf="f.codice.errors.required">
                    Campo obbligatorio
                </div>
            </div>
        </div>
        <div class="form-group">
            <h5><label for="nome" class="mandatory">Titolo:</label></h5>
            <input [formGroup]="editForm" formControlName="nome" maxlength="255" type="text" class="form-control" placeholder="Inserisci il titolo" [ngClass]="{
                    'form-control': true,
                    'is-invalid': submitted && f.nome.errors
                    }" />
            <div *ngIf="submitted && f.nome.errors" class="invalid-feedback" style="display: block;">
                <div *ngIf="f.nome.errors.required">
                    Campo obbligatorio
                </div>
            </div>
        </div>
        <div class="form-group">
            <h5><label for="tipologia" class="mandatory">Tipologia:</label></h5>

            <div [ngClass]="{ 'is-invalid': submitted && f.tipologia.errors }">
                <ng-select  [formGroup]="editForm" [items]="tipologie" bindValue="key" bindLabel="value" placeholder="Seleziona tipologia "
                  formControlName="tipologia" >
                </ng-select>
              </div>
              <div *ngIf="submitted && f.tipologia.errors" class="invalid-feedback" style="display: block;">
                <div *ngIf="f.tipologia.errors.required">
                  Campo obbligatorio
                </div>
              </div>            
        </div>
        <button class="btn btn-lg btn-primary btn-block" type="submit" style="margin:15px 0">
      {{buttonLabel}}
    </button>
    </form>
</ng-template>

<div class="container sfondo_bianco">
    <hr />
    <accordion [isAnimated]="true">
        <accordion-group heading="Inserisci nuovo sito rete natura">
            <ng-container *ngTemplateOutlet="templateEditAdd"></ng-container>
        </accordion-group>
    </accordion>
    <div class="mt-5">

        <ngx-datatable-wrapper #ngxDatatableWrapper [templates]="templateList" style="width: 100%; height: auto;" [dtOptions]="dtOptions">
            <ng-template #btnEditTemplate let-row="row" let-value="value">
                <a [ngClass]="{
            'disabled': loading
            }" class=" border-0 text-center" (click)="onEdit(row)" data-toggle="tooltip" data-placement="top" title="modifica dati">&nbsp;&nbsp;&ensp;<i class="far fa-edit"></i></a>
            </ng-template>
            <ng-template #btnDeleteTemplate let-row="row" let-value="value">
                <a [ngClass]="{
            'disabled': loading
            }" class=" border-0 text-center" (click)="onDelete(row)" data-toggle="tooltip" data-placement="top" title="elimina">&nbsp;&nbsp;&ensp;<i class="far fa-trash-alt"></i></a>
            </ng-template>
        </ngx-datatable-wrapper>
    </div>

    <ng-template #templateModal>
        <div class="modal-header  text-center">
            <h4 class="modal-title pull-left">Modifica sito rete natura</h4>
            <button type="button" class="close pull-right" aria-label="Close" (click)="closeModal()">
        <span aria-hidden="true">&times;</span>
      </button>
        </div>
        <div class="modal-body">
            <ng-container *ngTemplateOutlet="templateEditAdd"></ng-container>
        </div>
    </ng-template>


</div>